import { render, staticRenderFns } from "./CoverageGapBadge.vue?vue&type=template&id=ba23c5f4&scoped=true"
import script from "./CoverageGapBadge.vue?vue&type=script&setup=true&lang=js"
export * from "./CoverageGapBadge.vue?vue&type=script&setup=true&lang=js"
import style0 from "./CoverageGapBadge.vue?vue&type=style&index=0&id=ba23c5f4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../account/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba23c5f4",
  null
  
)

export default component.exports